import React, { useState, useEffect, useReducer } from 'react'
import { Button, ButtonGroup, Checkbox, Icon, IconButton, Modal, Row, Table } from 'rsuite'
import { budgetFormat } from '../../utils/formatterUtil'
import { maskIdCard } from '../../utils/dataUtil'
import { Controller, useForm } from 'react-hook-form'
import TooltipButton from '../../components/buttons/TooltipButton'
import { doneLoading, startLoading } from '../../utils/loading'
import { exportAnnualTaxRemittanceText } from '../../redux/actions/eFilling'
import { downloadFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'

export default function PostPaymentList({
  schema: _schema,
  onExport = () => {},
  requestExport,
  ...props
}) {
  const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [tableData, setTableData] = useState([])
  const [filteredItemsList, setFilteredItemsList] = useState([])
  const [filteredItemsStausModel, setFilteredItemsStausModel] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (_schema) {
      setTableData(_schema.values || [])
      setFormSchema(_schema)
    }
  }, [_schema])

  const handleOnExport = () => {
    onExport(requestExport)
  }

  const handlePreviewDetail = (rowData) => {
    // console.log('handlePreviewDetail => ', rowData)

    // console.log('formSchema => ', formSchema.values)

    const hasItems = Array.isArray(formSchema?.values) && formSchema?.values?.length > 0

    if (hasItems) {
      const controlSequenceNo = rowData.controlSequenceNo

      const filteredItems = Array.isArray(formSchema.values)
        ? formSchema.values.filter((item) => item.controlSequenceNo === controlSequenceNo)
        : []

      const totalSummary = filteredItems.reduce(
        (acc, item) => {
          acc.amountPaid += Number(item.amountPaid || 0)
          acc.amountPaidSubmission += Number(item.amountPaidSubmission || 0)
          acc.amountTax += Number(item.amountTax || 0)
          acc.amountTaxSubmission += Number(item.amountTaxSubmission || 0)

          return acc
        },
        {
          controlSequenceNo: null,
          id: null,
          withholdingYear: null,
          withholdingMonth: null,
          withholdingMonthLabel: null,
          datePayment: null,
          projectCode: null,
          contractNo: null,
          withholdingType: null,
          submitStatus: null,
          dataSource: null,
          runingSequenceNo: null,
          taxId: null,
          fullName: null,
          address: null,
          branch: null,
          amountPaid: 0,
          amountTax: 0,
          withholdingConditions: null,
          datePaymentSubmission: null,
          amountPaidSubmission: 0,
          amountTaxSubmission: 0,
          filingType: null,
          datePaymentTax: null,
          referenceNumber: null,
          receiptNumberSubmission: null,
          incomeAccording: null,
          typeSubmitted: null,
          dateSubmission: null,
          receiptNumber: null,
          dateReceipt: null,
          isTotal: true,
        }
      )

      filteredItems.push(totalSummary)

      console.log(filteredItems)

      setFilteredItemsList(filteredItems)

      setFilteredItemsStausModel(true)
    }
  }

  const onDownloadTextFile = async (rowData) => {
    setIsLoading(true)
    startLoading()
    try {
      const request = requestExport
      request.controlSequenceNo = rowData?.controlSequenceNo || ''

      let fileName = ''
      if (request.withholdingTypeValue === 1 || request.withholdingTypeValue === 4) {
        fileName = 'ภงด_1.txt'
      } else if (request.withholdingTypeValue === 2 || request.withholdingTypeValue === 5) {
        fileName = 'ภงด_3.txt'
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })

        return false
      }

      const file = await exportAnnualTaxRemittanceText(request)

      if (file) {
        downloadFile(file, fileName)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Row style={{ textAlign: 'end', marginTop: 10 }}>
        <ButtonGroup>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
            onClick={handleOnExport}
          >
            {formSchema?.buttonTxt?.deliveryListExport}
          </IconButton>
        </ButtonGroup>
      </Row>

      <Table
        wordWrap
        autoHeight
        data={formSchema?.headerValues || []}
        style={{ marginTop: 10 }}
        headerHeight={70}
      >
        <Column width={70} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              // if (rowData.isTotal) {
              //   return ''
              // }
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={170} resizable>
          <HeaderCell>ปี พ.ศ.(ปีภาษีที่หัก)</HeaderCell>
          <Cell dataKey="withholdingYear" />
        </Column>

        <Column width={180} resizable>
          <HeaderCell>สถานะยื่นแบบ</HeaderCell>
          <Cell dataKey="submitStatusLabel" />
        </Column>

        <Column width={170} resizable>
          <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.payAmount || 0)}</b>
              }
              return budgetFormat(rowData.payAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={170} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หัก</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.taxAmount || 0)}</b>
              }
              return budgetFormat(rowData.taxAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={180} resizable>
          <HeaderCell>จำนวนเงินที่จ่ายทั้งปี</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.yearTaxPayAmount || 0)}</b>
              }
              return budgetFormat(rowData.yearTaxPayAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หักและนำส่งทั้งปี</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.yearTaxSubmitAmount || 0)}</b>
              }
              return budgetFormat(rowData.yearTaxSubmitAmount || 0)
            }}
          </Cell>
        </Column>

        <Column width={170} resizable align="left">
          <HeaderCell>วันเดือนปีที่ชำระเงิน</HeaderCell>
          <Cell dataKey="yearTaxBillingDateLabel" />
        </Column>

        <Column width={160} resizable align="left">
          <HeaderCell>หมายเลขที่อ้างอิงในการยื่นแบบ</HeaderCell>
          <Cell dataKey="yearTaxBillingRefNo" />
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
          <Cell dataKey="yearTaxBillingNo" />
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
          <Cell dataKey="yearTaxSubmitDateLabel" />
        </Column>

        <Column width={120} align={'center'} fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <>
                  <ButtonGroup>
                    <TooltipButton
                      isStart={true}
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={() => {
                        handlePreviewDetail(rowData)
                      }}
                    />
                    <TooltipButton
                      isStart={false}
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      onClick={() => {
                        onDownloadTextFile(rowData)
                      }}
                    />
                  </ButtonGroup>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <Modal
        full
        show={filteredItemsStausModel}
        onHide={() => {
          setFilteredItemsStausModel(false)
        }}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ height: 800 }}>
            <Table
              wordWrap
              height={600}
              // minHeight={400}
              // autoHeight
              data={filteredItemsList || []}
              style={{ marginTop: 10 }}
              headerHeight={70}
              width={5050}
              shouldUpdateScroll={false}
            >
              <Column width={70} align="center">
                <HeaderCell>
                  <p style={{ color: '#313131' }}>
                    <b>ลำดับ</b>
                  </p>
                </HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (rowData.isTotal) {
                      return ''
                    }
                    return index + 1
                  }}
                </Cell>
              </Column>

              <Column width={170} resizable align="left">
                <HeaderCell>ปี พ.ศ.(ปีภาษีที่หัก)</HeaderCell>
                <Cell dataKey="withholdingYear" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>เดือน(ปีภาษีที่หัก)</HeaderCell>
                <Cell dataKey="withholdingMonthLabel" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>วันเดือนปีจ่าย</HeaderCell>
                <Cell dataKey="datePayment" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>รหัสโครงการ</HeaderCell>
                <Cell dataKey="projectCode" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
                <Cell dataKey="contractNo" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>ประเภทแบบ</HeaderCell>
                <Cell dataKey="withholdingType" />
              </Column>
              <Column width={180} resizable align="left">
                <HeaderCell>สถานะยื่นแบบ</HeaderCell>
                <Cell dataKey="submitStatus" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>ที่มาข้อมูล</HeaderCell>
                <Cell dataKey="dataSource" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>เลขลำดับนำส่ง</HeaderCell>
                <Cell dataKey="runingSequenceNo" />
              </Column>
              <Column width={190} resizable colSpan={3} align="left">
                <HeaderCell>เลขประจำตัวผู้เสียภาษี</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <p style={{ textAlign: 'center' }}>
                          <b>{maskIdCard(rowData.taxId)}</b>
                        </p>
                      )
                    }
                    return maskIdCard(rowData.taxId)
                  }}
                </Cell>
              </Column>
              <Column width={300} resizable align="left">
                <HeaderCell>ชื่อ</HeaderCell>
                <Cell dataKey="fullName" />
              </Column>

              <Column width={300} resizable align="left">
                <HeaderCell>ที่อยู่</HeaderCell>
                <Cell dataKey="address" />
              </Column>
              <Column width={150} resizable align="left">
                <HeaderCell>สาขา</HeaderCell>
                <Cell dataKey="branch" />
              </Column>
              <Column width={180} resizable align="left">
                <HeaderCell>วันเดือนปีที่จ่าย</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return (
                        <p style={{ textAlign: 'center' }}>
                          <b>{rowData.datePayment}</b>
                        </p>
                      )
                    }
                    return rowData.datePayment
                  }}
                </Cell>
              </Column>

              <Column width={150} resizable>
                <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountPaid || 0)}</b>
                    }
                    return budgetFormat(rowData.amountPaid || 0)
                  }}
                </Cell>
              </Column>

              <Column width={170} resizable>
                <HeaderCell>จำนวนเงินภาษีที่หัก</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountTax || 0)}</b>
                    }
                    return budgetFormat(rowData.amountTax || 0)
                  }}
                </Cell>
              </Column>

              <Column width={150} resizable align="left">
                <HeaderCell>เงื่อนไขการหัก</HeaderCell>
                <Cell dataKey="withholdingConditions" />
              </Column>

              <Column width={150} resizable align="left">
                <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
                <Cell dataKey="datePaymentSubmission" />
              </Column>

              <Column width={150} resizable>
                <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountPaidSubmission || 0)}</b>
                    }
                    return budgetFormat(rowData.amountPaidSubmission || 0)
                  }}
                </Cell>
              </Column>
              <Column width={160} resizable>
                <HeaderCell>จำนวนเงินภาษีที่หักและนำส่ง</HeaderCell>
                <Cell style={{ textAlign: 'right' }}>
                  {(rowData) => {
                    if (rowData.isTotal) {
                      return <b>{budgetFormat(rowData.amountTaxSubmission || 0)}</b>
                    }
                    return budgetFormat(rowData.amountTaxSubmission || 0)
                  }}
                </Cell>
              </Column>
              <Column width={190} resizable align="left">
                <HeaderCell>ยื่นแบบ (ปกติ/เพิ่มเติม)</HeaderCell>
                <Cell dataKey="filingType" />
              </Column>
              <Column width={170} resizable align="left">
                <HeaderCell>วันเดือนปีที่ชำระเงิน</HeaderCell>
                <Cell dataKey="datePaymentTax" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>หมายเลขที่อ้างอิงในการยื่นแบบ</HeaderCell>
                <Cell dataKey="referenceNumber" />
              </Column>
              <Column width={150} resizable align="left">
                <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
                <Cell dataKey="receiptNumberSubmission" />
              </Column>
              <Column width={150} resizable align="left">
                <HeaderCell>เงินได้ตามมาตรา</HeaderCell>
                <Cell dataKey="incomeAccording" />
              </Column>
              <Column width={140} resizable align="left">
                <HeaderCell>ประเภทแบบที่ยื่นเพื่อรายงานสรรพากรสิ้นปี</HeaderCell>
                <Cell dataKey="typeSubmitted" />
              </Column>
              <Column width={150} resizable align="left">
                <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
                <Cell dataKey="dateSubmission" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
                <Cell dataKey="receiptNumber" />
              </Column>
              <Column width={160} resizable align="left">
                <HeaderCell>วันเดือนปีของใบเสร็จ</HeaderCell>
                <Cell dataKey="dateReceipt" />
              </Column>
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <Button onClick={this.close} appearance="primary">
              Ok
            </Button> */}
          <Button
            onClick={() => {
              setFilteredItemsStausModel(false)
            }}
            appearance="subtle"
          >
            ปิด
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <Table
        wordWrap
        autoHeight
        data={formSchema?.values || []}
        style={{ marginTop: 10 }}
        headerHeight={70}
      >
        <Column width={70} align="center">
          <HeaderCell>
            <p style={{ color: '#313131' }}>
              <b>ลำดับ</b>
            </p>
          </HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (rowData.isTotal) {
                return ''
              }
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={170} resizable align="left">
          <HeaderCell>ปี พ.ศ.(ปีภาษีที่หัก)</HeaderCell>
          <Cell dataKey="withholdingYear" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เดือน(ปีภาษีที่หัก)</HeaderCell>
          <Cell dataKey="withholdingMonthLabel" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>วันเดือนปีจ่าย</HeaderCell>
          <Cell dataKey="datePayment" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>รหัสโครงการ</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เลขที่ข้อตกลง</HeaderCell>
          <Cell dataKey="contractNo" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>ประเภทแบบ</HeaderCell>
          <Cell dataKey="withholdingType" />
        </Column>
        <Column width={180} resizable align="left">
          <HeaderCell>สถานะยื่นแบบ</HeaderCell>
          <Cell dataKey="submitStatus" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>ที่มาข้อมูล</HeaderCell>
          <Cell dataKey="dataSource" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เลขลำดับนำส่ง</HeaderCell>
          <Cell dataKey="runingSequenceNo" />
        </Column>
        <Column width={190} resizable colSpan={3} align="left">
          <HeaderCell>เลขประจำตัวผู้เสียภาษี</HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isTotal) {
                return (
                  <p style={{ textAlign: 'center' }}>
                    <b>{maskIdCard(rowData.taxId)}</b>
                  </p>
                )
              }
              return maskIdCard(rowData.taxId)
            }}
          </Cell>
        </Column>
        <Column width={300} resizable align="left">
          <HeaderCell>ชื่อ</HeaderCell>
          <Cell dataKey="fullName" />
        </Column>

        <Column width={300} resizable align="left">
          <HeaderCell>ที่อยู่</HeaderCell>
          <Cell dataKey="address" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>สาขา</HeaderCell>
          <Cell dataKey="branch" />
        </Column>
        <Column width={180} resizable align="left">
          <HeaderCell>วันเดือนปีที่จ่าย</HeaderCell>
          <Cell>
            {(rowData) => {
              if (rowData.isTotal) {
                return (
                  <p style={{ textAlign: 'center' }}>
                    <b>{rowData.datePayment}</b>
                  </p>
                )
              }
              return rowData.datePayment
            }}
          </Cell>
        </Column>

        <Column width={150} resizable>
          <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountPaid || 0)}</b>
              }
              return budgetFormat(rowData.amountPaid || 0)
            }}
          </Cell>
        </Column>

        <Column width={170} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หัก</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountTax || 0)}</b>
              }
              return budgetFormat(rowData.amountTax || 0)
            }}
          </Cell>
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>เงื่อนไขการหัก</HeaderCell>
          <Cell dataKey="withholdingConditions" />
        </Column>

        <Column width={150} resizable align="left">
          <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
          <Cell dataKey="datePaymentSubmission" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>จำนวนเงินที่จ่าย</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountPaidSubmission || 0)}</b>
              }
              return budgetFormat(rowData.amountPaidSubmission || 0)
            }}
          </Cell>
        </Column>
        <Column width={160} resizable>
          <HeaderCell>จำนวนเงินภาษีที่หักและนำส่ง</HeaderCell>
          <Cell style={{ textAlign: 'right' }}>
            {(rowData) => {
              if (rowData.isTotal) {
                return <b>{budgetFormat(rowData.amountTaxSubmission || 0)}</b>
              }
              return budgetFormat(rowData.amountTaxSubmission || 0)
            }}
          </Cell>
        </Column>
        <Column width={190} resizable align="left">
          <HeaderCell>ยื่นแบบ (ปกติ/เพิ่มเติม)</HeaderCell>
          <Cell dataKey="filingType" />
        </Column>
        <Column width={170} resizable align="left">
          <HeaderCell>วันเดือนปีที่ชำระเงิน</HeaderCell>
          <Cell dataKey="datePaymentTax" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>หมายเลขที่อ้างอิงในการยื่นแบบ</HeaderCell>
          <Cell dataKey="referenceNumber" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
          <Cell dataKey="receiptNumberSubmission" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>เงินได้ตามมาตรา</HeaderCell>
          <Cell dataKey="incomeAccording" />
        </Column>
        <Column width={140} resizable align="left">
          <HeaderCell>ประเภทแบบที่ยื่นเพื่อรายงานสรรพากรสิ้นปี</HeaderCell>
          <Cell dataKey="typeSubmitted" />
        </Column>
        <Column width={150} resizable align="left">
          <HeaderCell>วันเดือนปีที่นำส่ง</HeaderCell>
          <Cell dataKey="dateSubmission" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>เลขที่ใบเสร็จรับเงิน</HeaderCell>
          <Cell dataKey="receiptNumber" />
        </Column>
        <Column width={160} resizable align="left">
          <HeaderCell>วันเดือนปีของใบเสร็จ</HeaderCell>
          <Cell dataKey="dateReceipt" />
        </Column>
      </Table> */}
    </>
  )
}
